import { TimeInForce } from "@goodfill/domain-properties";
import { TimeInForceComponent } from "@goodfill/domain-properties-components";
import {
  MultiselectCriteria,
  multiselectFilter,
  MultiselectFilterChangeFunction,
  MultiselectColumnDefinition,
} from "../generic/MultiselectColumnDefinition";

export const TIME_IN_FORCE_CRITERIA_KEY = "timeInForce";

export const timeInForceFilter = <TItemKey extends string>(key: TItemKey) =>
  multiselectFilter(TIME_IN_FORCE_CRITERIA_KEY, key);

export const TimeInForceColumnDefinition = <TItemKey extends string,>(
  itemKey: TItemKey,
  criteria: MultiselectCriteria<typeof TIME_IN_FORCE_CRITERIA_KEY, TimeInForce>,
  onFilterChange: MultiselectFilterChangeFunction<typeof TIME_IN_FORCE_CRITERIA_KEY, TimeInForce>,
) =>
  MultiselectColumnDefinition(
    "Time In Force",
    itemKey,
    TIME_IN_FORCE_CRITERIA_KEY,
    criteria,
    onFilterChange,
    [TimeInForce.Immediate, TimeInForce.CustomToday, TimeInForce.CustomFuture],
    (a: TimeInForce) => `${a}`,
    (a: string) => a as TimeInForce,
    150,
    (row) => <TimeInForceComponent value={row[itemKey]} />,
  );
